import React from 'react'
import Home from './Home/Home'
import Hero from './Hero/Hero'
import Features from './Features/Features'
import Testimonials from './Testimonials/Testimonials'
import Highlights from './Highlights/Highlights'
import FAQ from './FAQ/FAQ'
import Footer from './Footer/Footer'
import Pricing from './Pricing/Pricing'

const Main = () => {
  return (
    <div>
      <Home/>
    <Hero/>
    <Features/>
    <Testimonials/>
    <Highlights/>
    <Pricing/>
    <FAQ/>
    <Footer/>

    </div>
  )
}

export default Main
